import Promise from 'promise';
import { axios, CommonHelper, history, SVCMessage } from '../_helpers';
import { toastr } from 'react-redux-toastr';



export const TopicService = {
    GetAllTopicsAndSubTopics,
    getAllTopic,
    getCourseTopics,
    create,
    update,
    addTopic,
    deleteSubTopic,
    deleteTopicInfo,
    deleteTopic,
    getSubTopics,
    updateSubTopics,
    getCollectionTopics,
    addTopicsToCollections,
    fourceDeleteSubTopicVideos,
    addTopicToCollection,
    removeTopicFromCollection
};

//below service will fetch all topic and their subtopic
function GetAllTopicsAndSubTopics(isFormatedData = true) {
    return new Promise(function (resolve, reject) {
        axios.get('getAllTopicAndSubTopic').then((res) => {
            if (res.isSuccess) {
                //if isFormatedData is true, it will return topic and their subtopic
                if (isFormatedData) {
                    let data = res.data;
                    let topicAndSubtopic = [];
                    for (let topic of data.topics) {
                        let subTopic = [];
                        for (let st of data.subTopics) {
                            if (topic.topicId === st.topicId) {
                                subTopic.push(st);
                            }
                        }
                        topicAndSubtopic.push({ topicId: topic.topicId, name: topic.name, subTopic: subTopic });
                    }
                    resolve(topicAndSubtopic);
                } else {
                    // if isFormatedData is false, it will return topic and subtopic independently
                    resolve(res.data);
                }
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    })
};

//below service will fetch all topic
function getAllTopic() {
    // var url = JSON.parse(localStorage.getItem('user')).roles != 'User' ? 'selectAllTopic' : 'selectTopic?bookId=' + JSON.parse(localStorage.getItem('user')).bookId
    const user = JSON.parse(localStorage.getItem("user"));
    let url
    {
        if (CommonHelper.hasRole(user, ['User'])) {
            url = 'selectTopics?bookId=' + localStorage.getItem("bookId") // JSON.parse(localStorage.getItem('user')).bookId
        }
        else if (CommonHelper.hasRole(user, ['Admin'])) {
            url = 'selectAllTopic'
        }
    }
    return new Promise(function (resolve, reject) {
        axios.get(url).then((res) => {
            if (res.isSuccess) {
                resolve(res.data);
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    })
};

//below service will fetch all topic based on course id
function getCourseTopics(bookId) {
    return new Promise(function (resolve, reject) {
        axios.get('selectTopic?bookId=' + bookId).then((res) => {
            if (res.isSuccess) {
                resolve(res.data);
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    })
};

function create(topic, check) {
    let url;// =   topic.topicId?'createSubTopic':'createTopic'
    if (check) {
        url = 'createSubTopic';
    }
    else {
        url = 'createTopic';
    }
    return new Promise(function (resolve, reject) {
        axios.post(url, topic).then((res) => {
            if (res.isSuccess) {
                resolve(res);
            } else {
                toastr.error(SVCMessage[res.message]);
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    });
};

function update(course) {
    return new Promise(function (resolve, reject) {
        axios.post('updateTopic', course).then((res) => {
            if (res.isSuccess) {
                resolve(res);
            } else {
                toastr.error(res.message);
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    });
};

function addTopic(course) {
    // return axios.post('api/topic/create',course).then((response) => {
    //     return response.data;
    // }).catch((error) => {
    //     return Promise.reject(error);
    // });
};

function deleteSubTopic(sbTopicId) {
    return new Promise(function (resolve, reject) {
        // If No Videos added under this sub Topic delete it 
        axios.post('deleteSubTopicInfo', { subTopicId: sbTopicId }).then((res) => {
            if (res.isSuccess) {
                axios.post('deleteSubTopic', { subTopicId: sbTopicId, userId: JSON.parse(localStorage.getItem('user')).custom_person_id }).then((res) => {
                    if (res.isSuccess) {
                        toastr.success(SVCMessage[res.message]);
                        resolve(res);
                    } else {
                        reject(res.message);
                    }
                }).catch(error => {
                    reject(error.message);
                });
            } else {
                resolve(res);
            }
        }).catch(error => {
            reject(SVCMessage[error.message]);
        });
    });
};

function fourceDeleteSubTopicVideos(sbTopicId) {
    return new Promise(function (resolve, reject) {
        axios.post('deleteSubTopic', { subTopicId: sbTopicId, userId: JSON.parse(localStorage.getItem('user')).custom_person_id }).then((res) => {
            if (res.isSuccess) {
                toastr.success(SVCMessage[res.message]);
                resolve(res.data);
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    });
}

function deleteTopicInfo(topicId) {
    return new Promise(function (resolve, reject) {
        axios.post('deleteTopicInfo', {topicId: topicId}).then((res) => {
            resolve(res)
        }).catch(error => {
            reject(error.message);
        });
    });
};

function deleteTopic(topicId) {
    return new Promise(function (resolve, reject) {
        axios.get('deleteTopic?topicId=' + topicId).then((res) => {
            if (res.isSuccess) {
                toastr.success(SVCMessage[res.message]);
                resolve(res.data);
            } else {
                toastr.error(SVCMessage[res.message]);
                resolve(res);
            }
        }).catch(error => {
            reject(error.message);
        });
    });
};

function getSubTopics(topicId) {
    return new Promise(function (resolve, reject) {
        axios.get('selectSubTopic?topicId=' + topicId).then((res) => {
            if (res.isSuccess) {
                resolve(res.data);
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    });
};

function updateSubTopics(topicId) {
    return new Promise(function (resolve, reject) {
        axios.post('updateSubTopic', topicId).then((res) => {
            if (res.isSuccess) {
                resolve(res);
            } else {
                toastr.error(SVCMessage[res.message]);
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    });
};

function getCollectionTopics(collectionId) {
    return new Promise(function (resolve, reject) {
        let param = {
            collectionId: collectionId
        };
        axios.post('getCollectionWithTopic', param).then((res) => {
            if (res.isSuccess) {
                resolve(res.data);
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    });
}


function addTopicsToCollections(data) {
    return new Promise(function (resolve, reject) {
        axios.post('addTopicsToCollections', data).then((res) => {
            if (res.isSuccess) {
                toastr.success(SVCMessage[res.message]);
                resolve(res.data);
            } else {
                toastr.error(SVCMessage[res.message]);
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    });
}

function addTopicToCollection(data) {
    return new Promise(function (resolve, reject) {
        axios.post('addTopicToCollection', data).then((res) => {
            if (res.isSuccess) {
                toastr.success(SVCMessage[res.message]);
                resolve(res.data);
            } else {
                toastr.error(SVCMessage[res.message]);
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    });
}

function removeTopicFromCollection(data) {
    return new Promise(function (resolve, reject) {
        axios.post('removeTopicFromCollection', data).then((res) => {
            if (res.isSuccess) {
                toastr.success(SVCMessage[res.message]);
                resolve(res.data);
            } else {
                toastr.error(SVCMessage[res.message]);
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    });
}


// WEBPACK FOOTER //
// ./src/_services/topic.service.js